import React, { useState } from 'react';
import { Button, Form, Input, Select, Tabs } from 'antd';
import socialGoogle from "../../../assets/images/cover-images/social-google.svg";
import socialfacebook from "../../../assets/images/cover-images/social-fb.svg";
import "./Account.css";
import { SelectBirthYearOptions, SelectGenderOptions, SelectHighestEducationOptions } from '../../../constOptions/constOptions';
import { Link } from 'react-router-dom';

const { TabPane } = Tabs;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
    required: "${label} is required!",
    types: {
        email: "${label} is not a valid email!",
        number: "${label} is not a valid number!",
    },
    number: {
        range: "${label} must be between ${min} and ${max}",
    }
};
/* eslint-enable no-template-curly-in-string */

export const Account = () => {
    const [tabPosition] = useState('left');

    const onFinish = (values) => {
        console.log('Success:', values);
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <>
            <div className="ground-color-ashes">
                <div className="sector-account">
                    <div className="mtp-container">
                        <div className="sector-account-container">
                            <div>
                                <Tabs
                                    tabPosition={tabPosition}
                                    defaultActiveKey='1'
                                >
                                    <TabPane tab="Account" key="1" className="tab1">
                                        <div className="sector-account-content content-1">
                                            <div className="sector-account-card">
                                                <div className="account-heading">
                                                    <div className="account-title fw-600">Account</div>
                                                </div>
                                                <div className="account-content">
                                                    <div className="account-content-wrap">
                                                        <div className="account-content-inner">
                                                            <span className="account-content-text">divyesh@whiteorangesoftware.com</span>
                                                            <Form
                                                                autoComplete="off">
                                                                <Form.Item className="mb-0 text-center">
                                                                    <Button className="ant-btn ant-btn-default mtp-button button-alpha" htmlType="submit"> Change </Button>
                                                                </Form.Item>
                                                            </Form>
                                                        </div>
                                                        <span className="account-content-text">Social Connections - For quick and easy access, use your social accounts.</span>
                                                        <div className="account-social-wrap">
                                                            <div className="social-icon">
                                                                <img src={socialGoogle} alt="profile-cover" />
                                                            </div>
                                                            <span>Not Connected</span>
                                                            <div className="dashed">-</div>
                                                            <a href='https://www.google.com' className="social-signin-link fw-500">Sign in with Google</a>
                                                        </div>
                                                        <div className="account-social-wrap">
                                                            <div className="social-icon">
                                                                <img src={socialfacebook} alt="profile-cover" />
                                                            </div>
                                                            <span>Not Connected</span>
                                                            <div className="dashed">-</div>
                                                            <a href='https://www.google.com' className="social-signin-link fw-500">Sign in with Google</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sector-account-content content-2">
                                            <div className="sector-account-card">
                                                <div className="account-heading">
                                                    <div className="account-title fw-600">Password Reset</div>
                                                </div>
                                                <div className="account-content">
                                                    <div className="account-content-wrap">
                                                        <Form
                                                            layout="vertical"
                                                            className="mtp-form"
                                                            name="nest-messages"
                                                            initialValues={{ remember: true, }}
                                                            validateMessages={validateMessages}
                                                            onFinish={onFinish}
                                                            onFinishFailed={onFinishFailed}
                                                            autoComplete="off"
                                                        >
                                                            <div className="reset-passwd-form-wrap">
                                                                <Form.Item label="Current Password" name="Current Password" rules={[{ required: true, message: 'Please input your current password!', },]} >
                                                                    <Input.Password className="mtp-form-control" />
                                                                </Form.Item>
                                                            </div>
                                                            <div className="reset-passwd-form-wrap">
                                                                <Form.Item label="New Password" name="New Password" rules={[{ required: true, message: 'Please input your new password!', },]} >
                                                                    <Input.Password className="mtp-form-control" />
                                                                </Form.Item>
                                                            </div>
                                                            <div className="reset-passwd-form-wrap">
                                                                <Form.Item label="Confirm New Password" name="Confirm New Password" rules={[{ required: true, message: 'Please input your confirm new password!', },]} >
                                                                    <Input.Password className="mtp-form-control" />
                                                                </Form.Item>
                                                            </div>
                                                            <Form.Item className='button-save'>
                                                                <Button className="CustomButton mtp-button shine-transition" type="prime" htmlType="submit">
                                                                    Save Changes
                                                                </Button>
                                                            </Form.Item>
                                                        </Form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sector-account-content content-3">
                                            <div className="sector-account-card">
                                                <div className="account-heading">
                                                    <div className="account-title fw-600">Basic Information</div>
                                                </div>
                                                <div className="account-content">
                                                    <div className="account-content-wrap">
                                                        <Form
                                                            layout="vertical"
                                                            className="mtp-form"
                                                            name="nest-messages"
                                                            initialValues={{ remember: true, }}
                                                            validateMessages={validateMessages}
                                                            onFinish={onFinish}
                                                            onFinishFailed={onFinishFailed}
                                                            autoComplete="off"
                                                        >
                                                            <div className="basic-info-form-wrap">
                                                                <Form.Item label="First Name" name="First Name" rules={[{ required: true, message: 'Please input your first name!', },]} >
                                                                    <Input className="mtp-form-control" />
                                                                </Form.Item>
                                                                <Form.Item label="Last Name" name="Last Name" rules={[{ required: true, message: 'Please input your last name!', },]} >
                                                                    <Input className="mtp-form-control" />
                                                                </Form.Item>
                                                            </div>
                                                            <div className="basic-info-form-wrap">
                                                                <Form.Item label="Job Title" name="Job Title" rules={[{ required: true, message: 'Please input your job title!', },]} >
                                                                    <Input className="mtp-form-control" />
                                                                </Form.Item>
                                                                <Form.Item label="Gender" name="Gender" rules={[{ required: true, message: 'Please input your confirm new password!', },]} >
                                                                    <Select className="mtp-select-control" placeholder="Select Type" options={SelectGenderOptions} />
                                                                </Form.Item>
                                                            </div>
                                                            <div className="basic-info-form-wrap">
                                                                <Form.Item label="Birth Year" name="Birth Year" rules={[{ required: true, message: 'Please input your birth year!', },]} >
                                                                    <Select className="mtp-select-control" placeholder="Select Type" options={SelectBirthYearOptions} />
                                                                </Form.Item>
                                                                <Form.Item label="Highest Education" name="Highest Education" rules={[{ required: true, message: 'Please input your highest education!', },]} >
                                                                    <Select className="mtp-select-control" placeholder="Select Type" options={SelectHighestEducationOptions} />
                                                                </Form.Item>
                                                            </div>
                                                            <Form.Item className='button-save'>
                                                                <Button className="CustomButton mtp-button shine-transition" type="prime" htmlType="submit">
                                                                    Save Changes
                                                                </Button>
                                                            </Form.Item>
                                                        </Form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sector-account-content content-3">
                                            <div className="sector-account-card">
                                                <div className="account-heading">
                                                    <div className="account-title fw-600">Close Account</div>
                                                </div>
                                                <div className="account-content">
                                                    <div className="account-content-wrap">
                                                        <p>You can also <Link to='/coming-soon'>manage your email settings.</Link></p>
                                                    </div>
                                                    <div className="account-content-wrap">
                                                        <Form>
                                                            <Form.Item className='button-account-close'>
                                                                <Button className="CustomButton mtp-button shine-transition" type="prime" htmlType="submit">
                                                                    Close Account
                                                                </Button>
                                                            </Form.Item>
                                                        </Form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tab="Email and Alerts" key="2">
                                        <div className="sector-email-alerts">
                                            <p>Email and Alerts content</p>
                                        </div>
                                    </TabPane>
                                    <TabPane tab="Security & Privacy" key="3">
                                        <div className="sector-securty-privacy">
                                            <div className="sector-securty-privacy-card">
                                                <div className="securty-privacy-heading">
                                                    <div className="account-title fw-600">Security & Privacy</div>
                                                </div>
                                                <div className="account-content">
                                                    <div className="account-content-wrap">
                                                        <div className="account-content-title fw-500">Two-Factor Authentication</div>
                                                        <p>Activate this features for enhanced account security</p>
                                                    </div>
                                                    <div className="account-content-wrap">
                                                        <Form>
                                                            <Form.Item className='button-authentication'>
                                                                <Button className="CustomButton mtp-button shine-transition" type="prime" htmlType="submit">
                                                                    Set up two-factor authentication
                                                                </Button>
                                                            </Form.Item>
                                                        </Form>
                                                    </div>
                                                    <div className="account-content-wrap">
                                                        <p>
                                                            Two step verification gives you additional security by requiring a verification code whenever you sign in on new device.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}